import {parse} from 'query-string';
import userService from '../../../../services/user/UserService';
import {captureError} from '../../../../utils/log';
import history from '../../../../history/history';

export const getUsers = ({organisationId, pageSize}) => new Promise((resolve, reject) => {
  const {page} = parse(history.location.search);
  userService.searchByOrganisation(organisationId, '', page, pageSize)
    .then(({users, totalCount}) => {
      resolve({users, totalCount});
    })
    .catch(error => {
      captureError('Error while fetching organisation users', error);
      reject();
    });
});
